import { useMemo } from "react";
import { ConsumerExperimentsMap, CorpExperimentsMap } from "../types";
import { useExperiments } from ".";

interface CombinedKeys extends CorpExperimentsMap, ConsumerExperimentsMap {}

export const useExperimentsById = <T extends keyof CombinedKeys>(
  id: T
): CombinedKeys[T] | undefined => {
  const { experiments } = useExperiments();

  return useMemo(() => experiments[id], [experiments, id]);
};
